__turbopack_context__.v({
  "root": "tweet-skeleton-module__ZayCwq__root",
});
